import { useQuery } from '@hooks/reactQuery';

import { getCrowdCellDatesExist } from '@api/manageCrowdCells';

import { extractQueryParams } from '@utils/common';

import { IGetCrowdCellConfigDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';

import { CROWDCELLS_DATE_EXISTS } from '@constants/queryKeys';

export const useQueryCrowdCellDatesExist = (params?: IGetCrowdCellConfigDTO) => {
	const {
		crowdCellId,
		type,
	} = params || {};

	const {
		data: crowdCellConfigDateExists,
		isLoading: isLoadingCrowdCellConfigDateExists,
		isFetching: isFetchingCrowdCellConfigDateExists,
		isInitialLoading: isInitialLoadingCrowdCellConfigDateExists,
	} = useQuery({
		queryKey: [
			CROWDCELLS_DATE_EXISTS,
			params,
		],
		queryFn: extractQueryParams(getCrowdCellDatesExist),
		enabled: [type, crowdCellId],
		refetchOnWindowFocus: false,
	});

	return {
		crowdCellConfigDateExists: crowdCellConfigDateExists,
		isInitialLoadingCrowdCellConfigDateExists,
		isLoadingCrowdCellConfigDateExists,
		isFetchingCrowdCellConfigDateExists,
	};
};
